// Let Bootstrap handle positioning and keyboard interaction; dispose it with its Turbo-rendered toggle.
import { Controller } from '@hotwired/stimulus';
import { Dropdown } from 'bootstrap/dist/js/bootstrap.bundle.min.js';

export default class extends Controller {
  connect() {
    // Anchor to the viewport so scrollable rosters do not clip their menus.
    Dropdown.getOrCreateInstance(this.element, { popperConfig: { strategy: 'fixed' } });
  }

  disconnect() {
    Dropdown.getInstance(this.element)?.dispose();
  }
}
